import base64url from 'base64url';

export const base64urldecode = (x: string | undefined): string => (typeof x === 'string' ? base64url.decode(x) : '');
